export default __webpack_public_path__ + "static/media/tooth.30f0a75b.svg";